/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

function configs(labels, datasets, stacked = false) {
  return {
    data: {
      labels,
      datasets: datasets.map(ds => ({
        ...ds,
        barPercentage: 0.8, // Thicker bars (80% of available space)
        categoryPercentage: 0.9, // Less gap between categories
        maxBarThickness: 40, // Optional cap
      })),
    },
    options: {
      indexAxis: "y",
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          callbacks: {
            label: function (context) {
              let label = context.dataset.label || '';
              if (label) {
                label += ': ';
              }
              if (context.parsed.x !== null) {
                // Formatting: Show absolute value (Counts, not %)
                label += Math.abs(context.parsed.x).toLocaleString();
              }
              return label;
            }
          }
        }
      },
      scales: {
        y: {
          grid: {
            drawBorder: false,
            display: true,
            drawOnChartArea: true,
            drawTicks: false,
            borderDash: [5, 5],
            color: "#c1c4ce5c",
          },
          ticks: {
            display: true,
            padding: 10,
            autoSkip: false, // 🟢 Force show all labels
            color: "#9ca2b7",
            font: {
              size: 14,
              weight: 300,
              family: "Roboto",
              style: "normal",
              lineHeight: 2,
            },
          },
          // Ensure stacked if we want a true pyramid (optional, but standard bar chart works side-by-side too)
          stacked: stacked,
        },
        x: {
          grid: {
            drawBorder: false,
            display: false,
            drawOnChartArea: true,
            drawTicks: true,
            color: "#c1c4ce5c",
          },
          ticks: {
            display: true,
            color: "#9ca2b7",
            padding: 10,
            font: {
              size: 14,
              weight: 300,
              family: "Roboto",
              style: "normal",
              lineHeight: 2,
            },
            callback: function (value) {
              return Math.abs(value).toLocaleString();
            }
          },
          stacked: stacked, // Stacked to allow meeting in the middle 
        },
      },
      interaction: {
        mode: 'index', // Hover triggers all items at this index
        intersect: false,
        axis: 'y', // 🟢 Critical Fix: Ignore X-distance. Snap to nearest Y (Row).
      },
    },
  };
}

export default configs;
